import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { MapContainer, TileLayer, useMapEvents } from 'react-leaflet';
import ChangeView from '../ui/map_changeView';
import 'leaflet/dist/leaflet.css';
import '@bepo65/leaflet.fullscreen/Control.FullScreen.css';
import MapAnalyticsMarkers from './mapAnalytics-markers'; // redux

import { setMapBounds } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');

var hanldeMapCenterFormat = function hanldeMapCenterFormat(center) {
  if (_.isEmpty(center)) return {
    lat: 0,
    lng: 0
  };
  var latlngAry = center.split(', ');
  return {
    lat: latlngAry[1],
    lng: latlngAry[0]
  };
};

var MapAnalyticsMap = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$envCfg = _useSelector.envCfg,
      gisMapServiceApiUrl = _useSelector$envCfg.gisMapServiceApiUrl,
      gisMapZoomLevelMax = _useSelector$envCfg.gisMapZoomLevelMax,
      gisMapZoomLevelMin = _useSelector$envCfg.gisMapZoomLevelMin,
      gisMapInitViewportCenter = _useSelector$envCfg.gisMapInitViewportCenter,
      gisMapInitViewportZoom = _useSelector$envCfg.gisMapInitViewportZoom,
      selectedArea = _useSelector.trafficPrediction.selectedArea;

  var dispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      center = _useState2[0],
      setCenter = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      zoom = _useState4[0],
      setZoom = _useState4[1];

  var _mapRef = useRef();

  var isMounted = useRef(false);

  var MapEvent = function MapEvent() {
    var map = useMapEvents({
      zoomlevelschange: function zoomlevelschange(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      },
      moveend: function moveend(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      }
    });
    return null;
  };

  useEffect(function () {
    if (!isMounted.current) return;

    if (_.isEmpty(selectedArea)) {
      setZoom(gisMapInitViewportZoom);
      return setCenter(hanldeMapCenterFormat(gisMapInitViewportCenter));
    }

    setZoom(16);
    var newCenter = {
      lat: selectedArea.latitude,
      lng: selectedArea.longitude
    };
    setCenter(newCenter);
  }, [JSON.stringify(selectedArea)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
    return function () {
      setCenter();
      setZoom();
    };
  }, []);
  if (!gisMapServiceApiUrl) return null;
  return /*#__PURE__*/React.createElement(MapContainer, {
    whenCreated: function whenCreated(mapInstance) {
      _mapRef.current = mapInstance;
      setTimeout(function () {
        mapInstance.invalidateSize();
      }, 250);
    },
    id: "mapAnalytics-map",
    center: hanldeMapCenterFormat(gisMapInitViewportCenter),
    zoom: gisMapInitViewportZoom,
    zoomControl: false,
    attributionControl: false
  }, /*#__PURE__*/React.createElement(MapEvent, null), /*#__PURE__*/React.createElement(ChangeView, {
    center: center,
    zoom: zoom
  }), /*#__PURE__*/React.createElement(TileLayer, {
    url: gisMapServiceApiUrl,
    maxZoom: gisMapZoomLevelMax,
    minZoom: gisMapZoomLevelMin,
    crossOrigin: true
  }), /*#__PURE__*/React.createElement(MapAnalyticsMarkers, null));
});
export default MapAnalyticsMap;